/*
 * @Author: Zhouqi
 * @Date: 2025-12-12 14:30:00
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-19 10:12:51
 */
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

const VideoTranslatorSkeleton = () => {
  // 默认为 true，确保服务端和客户端初次渲染一致，避免 Hydration Error
  const [isLogin, setIsLogin] = useState(true);

  useEffect(() => {
    // 仅在客户端挂载后检查 Cookie
    const user = Cookies.get('user');
    setIsLogin(!!user);
  }, []);

  if (!isLogin) {
    return (
      <div className="relative flex p-[16px] h-full bg-[#f7f7f7] box-border overflow-hidden">
        {/* 左侧操作面板 - 保持不变 */}
        <div className="w-[328px] relative bg-[#ffffff] rounded-[8px] overflow-x-hidden flex flex-col">
          {/* 表单区域 */}
          <div className="flex-1 p-[12px] overflow-auto">
            <div className="flex flex-col gap-[16px]">
              {/* 视频上传区域 */}
              <div className="flex flex-col gap-[8px]">
                <div className="flex justify-between items-center mb-[8px]">
                  <div className="relative h-[16px] bg-gray-200 rounded-[4px] w-[100px] overflow-hidden">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                  <div className="relative h-[14px] bg-gray-200 rounded-[4px] w-[60px] overflow-hidden">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                </div>
                <div className="relative h-[120px] bg-gray-200 rounded-[6px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
              </div>

              {/* 语言选择区域 */}
              <div className="flex flex-col gap-[12px]">
                <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[80px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
                <div className="flex gap-[12px]">
                  {[...Array(2)].map((_, index) => (
                    <div key={index} className="flex-1 flex flex-col gap-[8px]">
                      <div className="relative h-[14px] bg-gray-200 rounded-[4px] max-w-[60px] overflow-hidden">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                      </div>
                      <div className="relative h-[40px] bg-gray-200 rounded-[6px] overflow-hidden">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* 开关选项区域 */}
              <div className="flex flex-col gap-[12px]">
                <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[100px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
                {/* Switch 选项 */}
                {[...Array(3)].map((_, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between py-[12px] border-b border-gray-100"
                  >
                    <div className="flex flex-col gap-[4px] flex-1">
                      <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[120px] overflow-hidden">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                      </div>
                      <div className="relative h-[12px] bg-gray-200 rounded-[4px] max-w-[180px] overflow-hidden">
                        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                      </div>
                    </div>
                    <div className="relative w-[44px] h-[24px] bg-gray-200 rounded-full overflow-hidden">
                      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 底部提交按钮 */}
          <div className="p-[12px] border-t border-gray-200">
            <div className="relative h-[44px] bg-gray-200 rounded-[6px] overflow-hidden">
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
          </div>
        </div>

        {/* 右侧未登录内容 (Hero Video + Demos) */}
        <div className="flex-1 ml-[16px] relative bg-[#ffffff] rounded-[8px] overflow-hidden flex flex-col items-center justify-center p-[24px]">
          {/* 模拟 Hero Video */}
          <div className="w-full max-w-[800px] aspect-video bg-gray-200 rounded-[12px] mb-[24px] overflow-hidden relative">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
          {/* 模拟 Demos */}
          <div className="w-full max-w-[800px] h-[200px] bg-gray-200 rounded-[12px] overflow-hidden relative">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>

        <style jsx>{`
          @keyframes shimmer {
            100% {
              transform: translateX(100%);
            }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="relative flex p-[16px] h-full bg-[#f7f7f7] box-border overflow-hidden">
      {/* 左侧操作面板 */}
      <div className="w-[328px] relative bg-[#ffffff] rounded-[8px] overflow-x-hidden flex flex-col">
        {/* 表单区域 */}
        <div className="flex-1 p-[12px] overflow-auto">
          <div className="flex flex-col gap-[16px]">
            {/* 视频上传区域 */}
            <div className="flex flex-col gap-[8px]">
              <div className="flex justify-between items-center mb-[8px]">
                <div className="relative h-[16px] bg-gray-200 rounded-[4px] w-[100px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
                <div className="relative h-[14px] bg-gray-200 rounded-[4px] w-[60px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
              </div>
              <div className="relative h-[120px] bg-gray-200 rounded-[6px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>

            {/* 语言选择区域 */}
            <div className="flex flex-col gap-[12px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[80px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              <div className="flex gap-[12px]">
                {[...Array(2)].map((_, index) => (
                  <div key={index} className="flex-1 flex flex-col gap-[8px]">
                    <div className="relative h-[14px] bg-gray-200 rounded-[4px] max-w-[60px] overflow-hidden">
                      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                    </div>
                    <div className="relative h-[40px] bg-gray-200 rounded-[6px] overflow-hidden">
                      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 开关选项区域 */}
            <div className="flex flex-col gap-[12px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[100px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              {/* Switch 选项 */}
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between py-[12px] border-b border-gray-100"
                >
                  <div className="flex flex-col gap-[4px] flex-1">
                    <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[120px] overflow-hidden">
                      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                    </div>
                    <div className="relative h-[12px] bg-gray-200 rounded-[4px] max-w-[180px] overflow-hidden">
                      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                    </div>
                  </div>
                  <div className="relative w-[44px] h-[24px] bg-gray-200 rounded-full overflow-hidden">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                </div>
              ))}
            </div>

            {/* 字幕选项区域 */}
            <div className="flex flex-col gap-[12px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[100px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              <div className="flex gap-[12px]">
                {[...Array(3)].map((_, index) => (
                  <div
                    key={index}
                    className="relative flex-1 h-[80px] bg-gray-200 rounded-[6px] overflow-hidden"
                  >
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                ))}
              </div>
            </div>

            {/* 字幕样式区域 */}
            <div className="flex flex-col gap-[12px]">
              <div className="relative h-[16px] bg-gray-200 rounded-[4px] max-w-[80px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
              <div className="flex gap-[12px]">
                {[...Array(3)].map((_, index) => (
                  <div
                    key={index}
                    className="relative w-[100px] h-[60px] bg-gray-200 rounded-[6px] overflow-hidden"
                  >
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 底部提交按钮 */}
        <div className="p-[12px] border-t border-gray-200">
          <div className="relative h-[44px] bg-gray-200 rounded-[6px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>
      </div>

      {/* 右侧任务面板 */}
      <div className="flex-1 relative bg-[#ffffff] rounded-[8px] overflow-x-hidden flex flex-col p-[24px]">
        {/* 任务列表标题 */}
        <div className="mb-[16px]">
          <div className="relative h-[20px] bg-gray-200 rounded-[4px] max-w-[120px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>

        {/* 任务列表骨架 */}
        <div className="flex flex-col gap-[16px]">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="relative h-[120px] bg-gray-200 rounded-[8px] overflow-hidden"
            >
              <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default VideoTranslatorSkeleton;
